import React from 'react';
import styles from "./index.scss";
import { SpecificDurationDropDown } from '../StaticData';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import Dropdown from "jd-library/Dropdown";

const SpecificTimeDuration = (props) => {
    return (
        <div className={styles["stds-container"]}>
            <InputWithMovingLabel
                input={{
                    value: props.productInfo.specificDuration || "",
                    onChange: e => {
                        props.updateEditProductDetail({ key: "specificDuration", value: e.target.value })
                    }
                }}
                label="Specific Duration"
                labelAlwaysUp
                holderClass={styles['middle-input']}
                hidePrependBar={true}
                showPreTextWithoutFocus={true}
                errorMessage={props.isError}
            />
            <Dropdown
                value={props.productInfo?.specificDurationUnit || 'months'}
                className={styles['specific-duration'] + " " + styles['marginB14']}
                valueClass={styles["drop-div"]}
                dropdownClass={styles['stds-options-zIndex']}
                onChange={e => {
                    props.updateEditProductDetail({
                        key: 'specificDurationUnit',
                        value: e.key
                    })
                }}
                optionList={SpecificDurationDropDown}
            />
        </div>
    )
}

export default SpecificTimeDuration